import { forwardRef, type Ref, type SVGProps } from "react";

function SvgLikeOutlined(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        d="M8 3.715c4.222-4.293 11.46 3.68 0 10.118C-3.46 7.394 3.778-.578 8 3.715Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgLikeOutlined);
export default ForwardRef;
